/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChildIndividualQuestionModeWithList } from './ChildIndividualQuestionModeWithList';
export type IndividualQuestionModelWithList = {
    readonly id?: number;
    name: string;
    question_type?: IndividualQuestionModelWithList.question_type;
    options?: Array<number>;
    description?: string | null;
    questionnaire?: number;
    new_options?: Array<string>;
    children_questions?: Array<ChildIndividualQuestionModeWithList>;
};
export namespace IndividualQuestionModelWithList {
    export enum question_type {
        TEXT = 'text',
        DATE = 'date',
        DROPDOWN = 'dropdown',
        MULTIPLE = 'multiple',
    }
}

